import { EntityLinksCard } from '@backstage/plugin-catalog';
import { useEntity } from '@backstage/plugin-catalog-react';
import { Grid } from '@backstage/ui';
import { EntityGridItemProps } from './EntityGridItemProps';

export const EntityLinksGridItem = (props: EntityGridItemProps) => {
  const { entity } = useEntity();
  return entity.metadata.links?.length ? (
    <Grid.Item colSpan={props.colSpan}>
      <EntityLinksCard />
    </Grid.Item>
  ) : null;
};
